<template>
  <div class="focusMonitoringList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId">
            <el-option key :label="$t('lang.lab_chooseGarden')" value=""></el-option>
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="unitinnernum" placeholder="请输入安装位置"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="registercode" placeholder="请输入电梯注册代码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="brand">
            <el-option label="请选择电梯品牌" value=""></el-option>
            <el-option v-for="(item,index) in brandList" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="commit()">查询</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="Place" label="安装位置" width="300">
        </el-table-column>
        <el-table-column prop="Brand" label="品牌">
        </el-table-column>
        <el-table-column prop="callState" label="困人">
          <template slot-scope="scope">
            <span v-if="scope.row.callState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.callState == 1" style="color:red;">困人</span>
          </template>
        </el-table-column>
        <el-table-column label="超限位">
          <template slot-scope="scope">
            <span v-if="scope.row.elevatortoppingState == 0&&scope.row.elevatorCrouchingState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.elevatortoppingState == 1" style="color:red;">冲顶</span>
            <span v-if="scope.row.elevatorCrouchingState == 1" style="color:red;">蹲底</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="elevatortoppingState" label="冲顶">
          <template slot-scope="scope">
            <span v-if="scope.row.elevatortoppingState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.elevatortoppingState == 1" style="color:red;">冲顶</span>
          </template>
        </el-table-column>
        <el-table-column prop="elevatorCrouching" label="蹲底">
          <template slot-scope="scope">
            <span v-if="scope.row.elevatorCrouchingState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.elevatorCrouchingState == 1" style="color:red;">蹲底</span>
          </template>
        </el-table-column> -->
        <el-table-column label="门故障">
          <template slot-scope="scope">
            <span v-if="scope.row.repeatedOpenAndClosingState == 0&&scope.row.runningOpenState == 0&&scope.row.closethedoorinplaceState == 0&&scope.row.doorMalfunction == 0" style="color:#67C23A;">正常</span>
            <span style="color:red;" v-if="scope.row.repeatedOpenAndClosingState == 1">反复开关门故障，</span>
            <span style="color:red;" v-if="scope.row.runningOpenState == 1">运行中开关门故障，</span>
            <span style="color:red;" v-if="scope.row.closethedoorinplaceState == 1">长时间开门故障，</span>
            <span style="color:red;" v-if="scope.row.doorMalfunction == 1">遮挡门故障</span>
          </template>
        </el-table-column>
        <el-table-column label="运行故障">
          <template slot-scope="scope">
            <span v-if="scope.row.carriageAccidentMove == 0&&scope.row.carriageUnlockStop == 0&&scope.row.overSpeedFault == 0&&scope.row.impatientStopError == 0" style="color:#67C23A;">正常</span>
            <span style="color:red;" v-if="scope.row.carriageAccidentMove == 1">轿厢意外移动，</span>
            <span style="color:red;" v-if="scope.row.carriageUnlockStop == 1">轿厢在开锁区域外停止，</span>
            <span style="color:red;" v-if="scope.row.overSpeedFault == 1">超速故障，</span>
            <span style="color:red;" v-if="scope.row.impatientStopError == 1">急停异常</span>
          </template>
        </el-table-column>
        <el-table-column label="运行异常">
          <template slot-scope="scope">
            <span v-if="scope.row.abnormalVibration == 0&&scope.row.unmannedHighRun == 0&&scope.row.longMoving == 0" style="color:#67C23A;">正常</span>
            <span style="color:red;" v-if="scope.row.abnormalVibration == 1">异常震动，</span>
            <span style="color:red;" v-if="scope.row.unmannedHighRun == 1">无人高频运行，</span>
            <span style="color:red;" v-if="scope.row.longMoving == 1">长时间运行故障</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="repeatedOpenAndClosing" label="反复开门">
          <template slot-scope="scope">
            <span v-if="scope.row.repeatedOpenAndClosingState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.repeatedOpenAndClosingState == 1" style="color:red;">异常</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="notFlatLayerState" label="基准层非平层">
          <template slot-scope="scope">
            <span v-if="scope.row.notFlatLayerState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.notFlatLayerState == 1" style="color:red;">异常</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="runningOpenState" label="运行中开门">
          <template slot-scope="scope">
            <span v-if="scope.row.runningOpenState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.runningOpenState == 1" style="color:red;">异常</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="closethedoorinplaceState" label="长时间开门">
          <template slot-scope="scope">
            <span v-if="scope.row.closethedoorinplaceState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.closethedoorinplaceState == 1" style="color:red;">异常</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="carriageoverhaulState" label="轿厢检修">
          <template slot-scope="scope">
            <span v-if="scope.row.carriageoverhaulState == 0" style="color:#67C23A;">正常</span>
            <span v-if="scope.row.carriageoverhaulState == 1" style="color:red;">检修</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="createTime" label="更新时间" sortable width="150">
          <template slot-scope="scope">
            {{ scope.row.createTime}}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="实时监测" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="videoDetail(scope.row)">实时监测</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:focusMonitoringList
   *@Description:电梯物联网集中监测列表
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.focusMonitoringList',
    data() {
      return {
        gardens: [], // 园区列表
        tableData: [], // table列表数据
        gardenId: '', // 选择园区的id（模糊查询）
        unitinnernum: '', // 安装位置
        registercode: '', // 注册代码
        brand: '', // 电梯品牌
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        brandList: [{
            name: '星玛',
            value: '星玛'
          },
          {
            name: '永大',
            value: '永大'
          },
          {
            name: '日立',
            value: '日立'
          },
          {
            name: '西子奥的斯',
            value: '西子奥的斯'
          },
          {
            name: '蒂森',
            value: '蒂森'
          },
          {
            name: '博林特',
            value: '博林特'
          },
          {
            name: '通力',
            value: '通力'
          },
          {
            name: '奥的斯',
            value: '奥的斯'
          },
          {
            name: '迅达',
            value: '迅达'
          },
          {
            name: '三菱',
            value: '三菱'
          },
          {
            name: '东芝',
            value: '东芝'
          },
        ], // 电梯品牌list
      }
    },
    created() {
      this.selectGarden()
      this.getData()
    },
    methods: {
      // 获取当前时间
      getDateNow() {
        const yy = new Date().getFullYear()
        const MM = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
        const dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
        const HH = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
        const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
        const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
        const date = yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
        return date
      },
      // 获取小区下拉
      selectGarden() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.gardens = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(
          `aapi/liftHistoryMonitor?gardenId=${this.gardenId}&unitinnernum=${this.unitinnernum}&registercode=${this.registercode}&brand=${this.brand}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
          ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
              this.tableData.createTime = this.getDateNow()
              for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].createTime = this.getDateNow()
              }
              console.log(this.tableData)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 实时监测详情
      videoDetail(rowData) {
        this.$router.push({
          name: 'realTimeMonitoringDetail',
          query: {
            object: rowData
          }
        })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
</style>